import { CallDetail, EventDetail } from '../../contacts/shared/models/Contact';
import { ContactHistory } from '../../contact-details/contacts-details.model';

type EventType = CallDetail | EventDetail | ContactHistory;

export function getMsisdnlabel(event: EventType) {
  if ('callerIdInfo' in event && event.callerIdInfo.label) {
    return event.callerIdInfo.label;
  } else if ('labelCallerId' in event) {
    return event.labelCallerId;
  } else if ('agentMsisdnLabel' in event) {
    return event.agentMsisdnLabel;
  } else {
    return '';
  }
}
